import { cn } from '@/lib/utils'
import Image from 'next/image'
import Link from 'next/link'

// const dark = 'https://heyboss.heeyo.ai/logo-dark.png'
const dark = '/v2/blacklogo.png'
const light = '/v2/lightlogo2.png'

interface LogoProps {
  openLinkInNewTab?: boolean
  variant?: 'light' | 'dark' | 'cyber'
  className?: string
}

export const Logo = ({
  variant = 'light',
  openLinkInNewTab = false,
  className,
}: LogoProps) => {
  const logo = variant === 'light' ? light : dark
  return (
    <Link
      href="/"
      target={openLinkInNewTab ? '_blank' : '_self'}
      className={cn(
        'text-2xl flex shrink-0 items-center gap-2 font-brand',
        className,
      )}
    >
      <Image
        width={322}
        height={965}
        src={logo}
        alt="logo"
        className="h-6 sm:h-6 md:h-8 lg:h-10 w-auto"
      />
    </Link>
  )
}
